/*
 * @Author: syyoon@yongtrim.com 
 * @Date: 2018-07-09 17:53:21 
 * @Last Modified by:   syyoon@yongtrim.com 
 * @Last Modified time: 2018-07-09 17:53:21 
 */


import { Injectable } from "@angular/core";
import { PlatformService } from "../services/platform.service";
import { AlertService } from "../services/alert.service";
declare var KakaoTalk: any;

@Injectable()
export class KakaoService {

  constructor(
    private platformService: PlatformService,
    private alertService: AlertService,
  ) {
  }


  login() {
    if (this.platformService.isWeb()) {
      // return Promise.resolve({
      //   id: 123456789,
      //   nickname: '셀럽',
      //   profile_image: 'http://placekitten.com/640/640'
      // })
      this.alertService.showToastMessage('웹에서는 사용하실 수 없습니다.');
      return Promise.reject({});
    }
    if (typeof KakaoTalk === undefined) {
      this.alertService.showToastMessage('카카오 플러그인이 설치되어있지 않습니다.');
      return Promise.reject({});
    }

    return new Promise((resolve, reject) => {
      KakaoTalk.login(result => {
        resolve(result);
      }, e => {
        this.alertService.showToastMessage('카카오 로그인중에 오류가 발생하였습니다.');
        reject({});
      });
    });
  }


  logout() {
    if (this.platformService.isWeb()) {
      return;
    }
    if (typeof KakaoTalk === undefined) {
      return;
    }

    KakaoTalk.logout();
  }

  share(data) {

    if (this.platformService.isWeb()) {
      return this.alertService.showToastMessage('웹에서는 사용하실 수 없습니다.');
    }
    if (typeof KakaoTalk === undefined) {
      return this.alertService.showToastMessage('카카오 플러그인이 설치되어있지 않습니다.');
    }

    KakaoTalk.share(data, () => {
    }, () => {
    });
  }


}


// WEBPACK FOOTER //
// ./src/services-sns/kakao.service.ts